import React from "react";

function Footer() {
  return (
    <footer className="footer dark">
      <p className="text-silver"> (©) 2020-2023 Charlie Puente |</p>
    </footer>
  );
}

export default Footer;
